import React,{useState} from 'react'
import axios from 'axios'
export default function Login() {
    const [username,SetUsername] = useState("")
    const [password,SetPassword] = useState("")
    const HandleSubmit = async ()=>{
       try {
        const res = await axios.post('https://gym-upp-api.onrender.com/api/signup',{
            username,
            password
        })
        console.log(res);
        res.data && window.location.replace('/')
       } catch (error) {
        console.log(error);
       }
    }
  return (
    <>
        <div className='bg-gradient-to-t from-[#3D0000] to-[#000000]  text-xl p-10 text-white font-[Roboto Condensed] pt-16 pb-16'>
        <h1 className=' text-5xl text-center font-[Poppins] py-8'>SignUp</h1>
        <div className=' lg:flex lg:justify-center lg:gap-72 border-black pt-16'>
        <div className=' flex flex-col justify-center gap-10 lg:gap-16 lg:pl-24 '>
        <input type="text" placeholder='Username' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl' onChange={(e)=>{SetUsername(e.target.value)}}/>
        <input type="password" placeholder='Password' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl' onChange={(e)=>{SetPassword(e.target.value)}}/>
        <button className=' bg-[#da1010] px-5 py-4 w-full text-white text-lg rounded-full hover:bg-[#3D0000]  my-6 m' onClick={HandleSubmit}> Register </button>
        </div>
        <img src="https://images.unsplash.com/photo-1590556409324-aa1d726e5c3c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDR8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=500&q=60" alt="..." className=' rounded-[3.5rem] pt-16 lg:w-96 w-full lg:pl-0 lg:pt-0 h-96' />
        </div>
        </div>
    </>
 )
}
